import { changeQuestionStatisticAnswer } from "../../../modules/_utils"
import axios from "axios";
import RestService from "../../../helpers/RestService";

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';


export function clearStatistic(questionId) {
  return async(dispatch) => {
    try {
      const {data} = await axios.post('/api/mcq1/clear-statistic', {questionId});
      changeQuestionStatisticAnswer({dispatch, questionId, statistic: null})
    } catch (error) {
      console.log("clearStatistic -> error", error)
    }
    
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/ClearStatisticForm/actions.js